import type { Props } from '.'

export interface Raw {
  acfFcLayout: 'headline_two'
  headlineTwo: Props
}

export interface Parsed {
  name: 'HeadlineTwo'
  props: Props
}

export function parser(rawComponent: Raw): Parsed {
  const props = rawComponent.headlineTwo

  return {
    name: 'HeadlineTwo',
    props,
  }
}
